/**
 * True on a reviewer's Kirim Approval link (/approval/r#token, or the older
 * /approval/r/:token). The reviewer
 * is outside JARVIS, so the page is always light; and a JARVIS user opening it
 * in the same browser must keep their own saved theme. Fixed at load: the page
 * is opened from an email, never navigated to.
 */
export const isApprovalLinkPage =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/approval/r' || window.location.pathname.startsWith('/approval/r/'));
